import React from 'react';
import { Box, Container, Typography, Button, Grid, Link } from '@mui/material';
import LazyLoad from 'react-lazyload';
import { useStyles } from './styles';
import { scrollToElement } from 'utils';
import useIsMobile from 'hooks/useIsMobile';
import NextLink from 'next/link';
import Faq from '../Faq';
import InfodesignJapan from 'components/InfodesignJapan';
import GraphicalThreeSteps from 'components/GraphicalThreeSteps';
import PublishedSection from 'components/PublishedSection';
import Testimonials from 'components/Testimonials';
import getRedirectUrlAfterLogin from 'utils/getRedirectUrlAfterLogin';

const testimonials = [
  {
    name: 'Margarida Agrochão',
    info: 'PhD student at Caltech / USA',
    text: 'Mind the Graphと同じことができるツールは他にありま せん！',
    image: '/images/testimonials/picture_margarida.png',
    socialLink: 'https://www.linkedin.com/in/margarida-agrochao-phd-52176116/',
  },
  {
    name: 'Meredith Thompson',
    info: 'MIT Researcher / USA',
    text: 'ジャーナルに投稿する論文のグラフィカル・アブストラクト のコンセプト作りに良いツールです。',
    image: '/images/testimonials/picture_meredith.png',
    socialLink: 'https://www.linkedin.com/in/meredith-thompson-5abb9837',
  },
  {
    name: 'Susanne Fiedler',
    info: 'PhD Student at LMU / Germany',
    text: 'とても簡単に使えて、グラフィックがすぐにデザイン できます。',
    image: '/images/testimonials/picture_susanne.png',
    socialLink: 'https://www.facebook.com/zusanne.fiedler.7/',
  },
  {
    name: 'Shermel Sherman',
    info: 'Predoctoral Research Assistant at UT / USA',
    text: '巣作りのイラストが完璧でした。ありがとう！',
    image: '/images/testimonials/shermel.png',
    socialLink: 'https://www.researchgate.net/profile/Shermel_Sherman',
  },
  {
    name: 'Oscar García Miranda',
    info: 'Student at UDLAP  / Mexico',
    text: 'ありがとう！最高のツールです！',
    image: '/images/testimonials/oscar.png',
    socialLink: 'https://www.researchgate.net/profile/Oscar_Garcia-Miranda',
  },
  {
    name: 'Mahmoud Slim',
    info: 'Phd at Ave / Canada',
    text: 'サポートしてくれてありがとう！',
    image: '/images/testimonials/mahmoud.png',
    socialLink: 'https://www.researchgate.net/profile/Mahmoud_Slim',
  },
  {
    name: 'Benjamin Zeitlin',
    info: 'Teacher at UOP / USA',
    text: 'ありがとう、自分がまさに欲しいツールでした！',
    image: '/images/testimonials/benjamin.png',
    socialLink: 'https://www.researchgate.net/profile/Benjamin_Zeitlin',
  },
  {
    name: 'Lara Moreno Zarate',
    info: 'PhD student at UCLM / Spain',
    text: 'こんなプラットフォームを実現できて、おめでとうございます。 本当にすごい。',
    image: '/images/testimonials/lara.png',
    socialLink: 'https://www.researchgate.net/profile/Lara_Moreno-Zarate',
  },
  {
    name: 'Selen Uman',
    info: 'PhD Student at UPENN / USA',
    text: 'グラフィックの見た目が素晴らしい！ありがとうございま す！',
    image: '/images/testimonials/selen.png',
    socialLink: 'https://www.gatescambridge.org/members-area/connect/directory/scholar/7252',
  },
  {
    name: 'Mohammed K Hankir',
    info: 'Basic Scientist at JMU / Germany',
    text: '使い始めて最初の日から、プロフェッショナルなプレゼンス ライドや出版物の図を作ることができました。',
    image: '/images/testimonials/mohammed.png',
    socialLink: 'https://www.researchgate.net/profile/Mohammed_Hankir2',
  },
  {
    name: 'Emily Landon',
    info: 'Executive Medical Director at UC / USA',
    text: '本当に素晴らしいチーム！',
    image: '/images/testimonials/emily.png',
    socialLink: 'https://www.researchgate.net/profile/Emily_Landon2',
  },
  {
    name: 'Gabriela Torres Mattos',
    info: 'PhD student at UFRGS / Brazil',
    text: '間違ったプランを購入してしまったのですが、サポートチー ムがすぐに問題に対応してくれました。',
    image: '/images/testimonials/gabriela.png',
    socialLink: 'http://lattes.cnpq.br/6037855682278478',
  },
  {
    name: 'Benedikt Heuckmann',
    info: 'PostDoc at Leibniz Universität Hannover / Germany',
    text: 'サポートは素晴らしいし、イラストは科学的に正確です。 助けてくれて本当にありがとう。このサービスは本当に最 高です。',
    image: '/images/testimonials/benedikt.png',
    socialLink: 'https://www.researchgate.net/profile/Benedikt_Heuckmann',
  },
  {
    name: 'Sonali Raghunath',
    info: 'PhD Student at UMN / USA',
    text: '科学論文に入れるグラフィックを、自分がちょうど表現した いように、簡単にデザインできます。',
    image: '/images/testimonials/sonali.png',
    socialLink: 'https://www.researchgate.net/profile/Sonali_Raghunath2',
  },
  {
    name: 'Amro Hussien',
    info: 'PhD Student at ETH Zürich / Switzerland',
    text: '簡単に使えて、綺麗なグラフィック、そして膨大なイラスト ライブラリ。',
    image: '/images/testimonials/amro.png',
    socialLink: 'https://biomech.ethz.ch/the-institute/people/person-detail.html?persid=208489',
  },
  {
    name: 'Kaian Teles',
    info: 'PhD student at UnB / Brazil',
    text: 'Mind the Graphは、美しく使いやすいテンプレートがあ るのでお気に入りです。',
    image: '/images/testimonials/kaian.png',
    socialLink: 'https://www.researchgate.net/profile/Kaian_Teles',
  },
];

export default function MainContent() {
  const classes = useStyles();
  const isMobile = useIsMobile();

  function scrollActionClick() {
    const headerElement = document.getElementById('header');

    scrollToElement(headerElement);
  }

  return (
    <>
      <Box bgcolor="#F1F1F1" pt={10} pb={5}>
        <Typography className={classes.primaryColor} variant="h4" component="h2" align="center">
          <b>思い描いたイメージを、すぐにグラフィックに！</b>
        </Typography>

        <Box my={3}>
          <Typography variant="h6" component="p" align="center">
            Mind the Graph は、科学者が自分自身で簡単に科学イラストを作成できるソフトウエアです
          </Typography>
        </Box>

        <Typography variant="h6" component="p" align="center">
          私たちのミッションは、すべての科学者をデザイナーにすること、そして、 <br />
          効果的な科学コミュニケーションに役立つイメージ素材を提供することで、彼らの創造性を解き放つことです。
        </Typography>
      </Box>

      <Box>
        <GraphicalThreeSteps
          showButton={true}
          textButton="今すぐ作成する"
          mainTitle="３ステップで簡単！科学イラストの作成方法"
          subTitle="Mind the Graphで科学コミュニケーションをもっとシンプルに"
          titleStepOne="1. テンプレートを選ぶ"
          titleStepTwo="2. すべてをカスタマイズ"
          titleStepThree="3. ダウンロードして共有"
          descriptionStepOne="300以上のテンプレー トからお好きなスタイルをお選びください。"
          descriptionStepTwo="テンプレートのイラスト、文字、図形色など すべての要素を編集・カスタマイズできます。 また、イメージギャラリーからイラストを選んだり、 研究にピッタリ合ったイラストを新し くオーダーすることもできます。"
          descriptionStepThree="作成したイラストをPNG、TIFF またはPDF形式で、解像度を選んでダウロー ドしジャーナルや出版物等に活用できます。"
        />
      </Box>

      <LazyLoad offset={100}>
        <Box px={6} py={6} bgcolor="#F1F1F1">
          <Grid container={true} spacing={2} alignItems="center">
            <Grid item={true} xs={12} md={6}>
              <Link onClick={scrollActionClick} underline="hover">
                <img
                  className={classes.sectionImage}
                  src="/images/science-figures/keep-readers.webp"
                  loading="lazy"
                  alt="科学イラスト例"
                />
              </Link>
            </Grid>
            <Grid item={true} xs={12} md={6}>
              <Box px={6}>
                <img
                  src="/images/science-figures/keep-readers-icon.webp"
                  loading="lazy"
                  alt="Keed readers interested icon"
                />

                <Box py={2}>
                  <Typography variant="h2" className={classes.titleContent} gutterBottom={true}>
                    世界最大級の <br /> 科学イラストギャラリー
                  </Typography>
                </Box>

                <Typography>
                  80以上の研究分野をカバーする70,000点の科学イラスト <br />{' '}
                  ギャラリーから検索できます ピッタリのイラストで、あなたの <br />{' '}
                  研究を際立たせましょう。
                </Typography>

                <NextLink href={getRedirectUrlAfterLogin()} passHref={true}>
                  <Button className={classes.button} color="primary" variant="contained">
                    今すぐ作成する
                  </Button>
                </NextLink>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </LazyLoad>

      <LazyLoad offset={100}>
        <InfodesignJapan />
      </LazyLoad>

      {!isMobile && (
        <LazyLoad offset={100}>
          <Box display="flex" bgcolor="#EEEEEE" pt={15} pb={10} justifyContent="center">
            <NextLink href="/pricing" passHref={true}>
              <Button className={classes.priceButton} variant="contained">
                価格を見る
              </Button>
            </NextLink>
          </Box>
        </LazyLoad>
      )}

      <LazyLoad offset={100}>
        <Box py={2}>
          <PublishedSection titlePublished="Mind the Graphの科学イラストレーションは、次の出版社から出版されています。" />
        </Box>
      </LazyLoad>

      <LazyLoad offset={100}>
        <Box className={classes.mainTestimonials}>
          <Container>
            <Testimonials showActionButton={false} testimonialsTranslated={testimonials} />
          </Container>
        </Box>
      </LazyLoad>

      <LazyLoad offset={100}>
        <Box py={6}>
          <Container>
            <Faq />
          </Container>
        </Box>
      </LazyLoad>
    </>
  );
}
